import { useEffect, useState } from "react";
import { Box, Button, FormLabel, default as TextField, Typography } from "@mui/material";
import InputBasic from "../ProfilesComp/InputsBasic";
import InputsYorN from "../ProfilesComp/InputsYorN"; // Asegúrate de importar este componente si lo necesitas
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { updateSection } from "../../../store/Profiles/profilesSlice";

const StepSpirituality = ({ onBack, onNext }) => {
    const dispatch = useDispatch();
    const storedData = useSelector((state) => state.profiles.Spirituality) || {};
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        religionRole: "",
        clientValues: "",
        rituals: "",
        ritualsDescription: "",
        sleepPattern: ""
    });

    useEffect(() => {
        setFormData((prevData) => ({
            ...prevData,
            ...storedData
        }));
    }, [storedData]);

    const handleChange = (key, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [key]: value
        }));
    };

    const handleNextStep = async () => {
        await handleSaveData(); // 🔹 Espera que termine antes de seguir
        onNext();
    };

    const handleSaveData = async () => {
      dispatch(updateSection({ section: "Spirituality", data: { Spirituality:formData } }));
    }
    return (
        <>
            <Typography variant="h5" gutterBottom>
                {t("Profiles.Spirituality.Spirituality")}
            </Typography>

            <InputBasic 
                Translation="Profiles.Spirituality.HowdoesReligionplay"
                value={formData.religionRole}
                onChange={(e) => handleChange("religionRole", e.target.value)}
            />
            <InputBasic 
                Translation="Profiles.Spirituality.Whatgivestheclient’s"
                value={formData.clientValues}
                onChange={(e) => handleChange("clientValues", e.target.value)}
            />
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 3 }}>
                <InputsYorN 
                    translationKey={t("Profiles.Spirituality.Arethereanyrituals")}
                    value={formData.rituals}
                    onChange={(value) => handleChange("rituals", value)}
                />
            </Box>
            {formData.rituals === "yes" && (
                <InputBasic 
                    Translation="Profiles.Spirituality.Ifyes,please"
                    value={formData.ritualsDescription}
                    onChange={(e) => handleChange("ritualsDescription", e.target.value)}
                />
            )}
            
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 3 }}>
                <FormLabel component="legend">{t("Profiles.Spirituality.Describeyoursleeppattern")}</FormLabel>
            </Box>
            <InputBasic 
                value={formData.sleepPattern}
                multiline
                rows={6}
                onChange={(e) => handleChange("sleepPattern", e.target.value)}
            />
            {/* Botones */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                <Button startIcon={<ArrowBackIcon />} onClick={onBack} variant="outlined">
                    {t("common.back")}
                </Button>
                <Button endIcon={<ArrowForwardIcon />} onClick={handleNextStep} variant="contained" color="primary">
                    {t("common.next")}
                </Button>
            </Box>
        </>
    );
};

export default StepSpirituality;
